import React from 'react';
import { SectionHeader, FadeIn } from '../ui';
export function ObjectionKiller() {
  const questions = [{
    q: 'Can they prove long-term quality?',
    a: 'Yes. 50+ years building in Perth, consistently recognised by HIA and MBA.'
  }, {
    q: 'Can they show completed homes?',
    a: 'Yes. We proudly showcase 8 named homes in our portfolio, built to last.'
  }, {
    q: 'Recognised by HIA & MBA?',
    a: 'Yes, consistently since 1995.'
  }, {
    q: 'Will communication be clear?',
    a: 'Yes. You have a dedicated team and prestart clarity with no nasty surprises.'
  }, {
    q: 'Can you meet the people?',
    a: 'Yes. Our directors are hands-on and accessible throughout your build.'
  }, {
    q: 'Can they evaluate your block before you buy?',
    a: 'Yes. We offer preliminary site evaluation to ensure it fits your vision.'
  }, {
    q: 'Can you walk a current display home?',
    a: 'Yes. Visit Latitude in Applecross to experience our quality firsthand.'
  }, {
    q: 'Do they understand Perth luxury living?',
    a: 'Yes. Three generations of local expertise.'
  }];
  return <section className="py-16 md:py-24 bg-white border-y border-atrium-stone/30" data-id="element-288">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-289">
        <FadeIn data-id="element-290">
          <SectionHeader eyebrow="Before You Choose" title="Before you choose a luxury builder, ask these questions" className="text-center max-w-3xl mx-auto" data-id="element-291" />
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8 mt-16" data-id="element-292">
          {questions.map((item, index) => <FadeIn key={index} delay={index % 2 * 100} data-id="element-293">
              <div className="flex items-start gap-4 p-6 bg-atrium-ivory/50 hover:bg-atrium-ivory transition-colors duration-300" data-id="element-294">
                <div className="mt-1 flex-shrink-0" data-id="element-295">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-atrium-bronze" strokeWidth="1.5" data-id="element-296">
                    <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" data-id="element-297" />
                  </svg>
                </div>
                <div data-id="element-298">
                  <h4 className="font-serif text-lg text-atrium-ink mb-2" data-id="element-299">
                    {item.q}
                  </h4>
                  <p className="text-sm text-atrium-ink/70 leading-relaxed" data-id="element-300">
                    {item.a}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}